module.exports = __webpack_public_path__ + "static/idea.7e0098c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/StartUp/img/idea.png
// module id = 826
// module chunks = 110243015079028